import { FC, memo } from 'react'
import { useRouter } from 'next/router'

import PlaylistCard from '../playlist-card/playlist-card'
import ScrollArea from 'containers/scroll-area/scroll-area'

import { IMaterialCard } from 'constants/types/card.types'
import { getDigitFromString } from 'utils/getURLData'

import styles from './playlist.module.scss'

interface IPlaylist {
  data: IMaterialCard[]
  modificator?: string
}

const Playlist: FC<IPlaylist> = ({ data, modificator }) => {
  const router = useRouter()
  const { query } = router
  const { id } = query
  const currWebinar = getDigitFromString(id as string)

  return (
    <ScrollArea modificator={modificator}>
      <div className={styles.scrollContent}>
        {data.map((card, index) => (
          <PlaylistCard key={index} {...card} index={index} originWebinar={currWebinar} />
        ))}
      </div>
    </ScrollArea>
  )
}

export default memo(Playlist)
